import { useContext } from 'react'

import { faFileAlt } from '@fortawesome/pro-solid-svg-icons'

import ClickableIcon from '../../../Components/antd/Buttons/ClickableIcon'
import { InternshipRequestFilesDrawerContext } from '../../institution/InternshipsView/InternshipsRequestsView/InternshipRequestFilesDrawer'
import { isNonEmptyArray, isObject } from '../../../utils'
import { ColorsPalette } from '../../../config/colors'

const InternshipRequestFilesIcon = ({ internshipRequest }) => {
  const irf = useContext(InternshipRequestFilesDrawerContext)

  const handleClick = () => {
    if (isObject(irf)) {
      irf.setHandler(handler => ({ ...handler, data: internshipRequest }))
    }
  }

  return (
    <ClickableIcon
      icon={faFileAlt}
      color={isNonEmptyArray(internshipRequest.files) ? 'green' : ColorsPalette.STEEL_BLUE}
      onClick={handleClick}
    />
  )
}

export default InternshipRequestFilesIcon
